import type { RootState } from '@/store';

export const selectApplicationData = (state: RootState) => state.application.data || ({} as Application);
